import { render } from "./MessageTempate.vue?vue&type=template&id=e9c68224&scoped=true&lang=pug"
import script from "./MessageTempate.vue?vue&type=script&lang=js"
export * from "./MessageTempate.vue?vue&type=script&lang=js"

import "./MessageTempate.vue?vue&type=style&index=0&id=e9c68224&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c68224"]])

export default __exports__